import { render } from "./ActionGroup.vue?vue&type=template&id=da6587d4&scoped=true"
import script from "./ActionGroup.vue?vue&type=script&lang=js"
export * from "./ActionGroup.vue?vue&type=script&lang=js"

import "./ActionGroup.vue?vue&type=style&index=0&id=da6587d4&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da6587d4"]])

export default __exports__